export default {
    type: 'testimonial-modules',
    aliases: {
        camel: 'testimonialModules',
        singular: 'Testimonial module',
        plural: 'Testimonial modules',
        lowerSingular: 'testimonial module',
        lowerPlural: 'testimonial modules',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
